const excelMime = "application/vnd.ms-excel;charset=utf-8";

const escapeXml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const cellValue = (col, row, index) => {
  if (typeof col.value === "function") return col.value(row, index);
  if (col.key) {
    const parts = String(col.key).split(".");
    let cur = row;
    for (const p of parts) cur = cur?.[p];
    return cur ?? "";
  }
  return "";
};

/**
 * Downloads an Excel-openable .xls file from column defs + row objects.
 * columns: [{ label, key? | value(row, index) }]
 */
export function downloadExcel(filename, columns, rows) {
  if (!Array.isArray(columns) || columns.length === 0) {
    throw new Error("Nothing to export");
  }
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error("No records to export");
  }

  const header = columns
    .map((c) => `<th>${escapeXml(c.label || c.key || "")}</th>`)
    .join("");
  const body = rows
    .map(
      (row, index) =>
        `<tr>${columns
          .map((c) => `<td>${escapeXml(cellValue(c, row, index))}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
<head><meta charset="UTF-8" /></head>
<body>
<table>
<thead><tr>${header}</tr></thead>
<tbody>${body}</tbody>
</table>
</body>
</html>`;

  const blob = new Blob(["\uFEFF", html], { type: excelMime });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  const safeName = String(filename || "export").replace(/\.xlsx?$/i, "");
  a.href = url;
  a.download = `${safeName}.xls`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function exportTable(filename, columns, rows, notify) {
  try {
    downloadExcel(filename, columns, rows);
    notify?.("Excel downloaded", "success");
    return true;
  } catch (err) {
    notify?.(err?.message || "Export failed", "error");
    return false;
  }
}

export const LEDGER_EXPORT_COLUMNS = [
  { label: "S.NO", value: (_r, i) => i + 1 },
  { label: "TRANS DATE", key: "date" },
  { label: "DESCRIPTION", value: (r) => r?.narration || "Opening Balance" },
  { label: "DEBIT", key: "debit" },
  { label: "CREDIT", key: "credit" },
  { label: "BALANCE", key: "closingBalance" },
];
